import { SchemaDefinition, UnknownSchema } from '@rehaje/core'

import type { SchemaMetadataSpecific, TypedSchema } from '@rehaje/core'

export interface SchemaJavaScriptSpecific extends SchemaMetadataSpecific {
  /**
   * 默认值
   */
  default?: any
  type: 'Schema.JavaScript'
  /**
   * 具体值
   */
  value?: any
}

export class SchemaJavaScriptDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaJavaScriptSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaJavaScriptSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaJavaScriptSpecific): TypedSchema {
    return {
      ...this.inferOnlySchema(schema),
      value: target
    }
  }

  override inferOnlySchema(schema: SchemaJavaScriptSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaJavaScriptSpecific): string {
    if (typeof schema?.value === 'function') return 'Function'
    if (schema?.value !== undefined)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(target: any) {
    return target
  }

  override validate(target: any, schema: SchemaJavaScriptSpecific): void {
    this.validateMetadata(target, schema)
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.JavaScript': SchemaJavaScriptSpecific
  }
}
